import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

const useStyles = makeStyles(theme => ({
  paper: {
    padding: theme.spacing(4, 2),
    marginBottom: theme.spacing(2)
  }
}));


export default function KjosandiAtkvaedi(props) {
  const classes = useStyles();
  const { formState, setFormState, atkvaediOptions } = props;

  function handleAtkvaediChange(e) {
    setFormState(state => ({...state, atkvaediTegundId: parseInt(e.target.value)}));
  }

  return (
    <Paper className={classes.paper}>
      <Grid container direction="row" alignItems="center" justify="center">
        <FormControl component="fieldset" className={classes.formControl}>
          <FormLabel component="legend">Tegund atkvæðis:</FormLabel>

          <RadioGroup
            aria-label="skil"
            name="skil"
            value={formState.atkvaediTegundId}
            onChange={handleAtkvaediChange}
          >
            <Grid item xs>
              {atkvaediOptions
                .filter(opt => opt.id !== 6) // Aðsent atkvæði ekki möguleiki hér.
                .map(opt => (
                  <FormControlLabel
                    key={opt.id}
                    value={opt.id}
                    control={<Radio />}
                    label={opt.lysing}
                  />
                ))
              }
            </Grid>
          </RadioGroup>
        </FormControl>
      </Grid>
    </Paper>
  );
}